import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://escdeydledgzculfwmeg.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVzY2RleWRsZWRnemN1bGZ3bWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYzNDEzNzksImV4cCI6MjA1MTkxNzM3OX0.Y-rIuiGDAYLRucFvmK_d5apfnkxveTQv0fARCyvoxBU";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});